import { render, staticRenderFns } from "./TokenManagementMasterWallet.vue?vue&type=template&id=38e4f803&scoped=true&lang=pug"
import script from "./TokenManagementMasterWallet.vue?vue&type=script&lang=ts"
export * from "./TokenManagementMasterWallet.vue?vue&type=script&lang=ts"
import style0 from "./TokenManagementMasterWallet.vue?vue&type=style&index=0&id=38e4f803&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4f803",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
